import React, {  useEffect, useState } from 'react'
import DashboardWorldMap from '../components/charts/DashboardWorldMap'
import moment from 'moment';


import {
  loadUsers,
  filterUsers
  
} from "../utils/Network";
import { userAvatar } from '../utils';

export default function OnlineContent() {

    const [worldMapInfo, setWorldMapInfo] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState(null);

    useEffect(() => {
        
        _getAllParticipants()

    }, []);

    
    const _getAllParticipants=()=>{
    
        filterUsers("&size=45000000",1,true).then((response) => {
            if (response && response.results) {
                _OnlineUsers(response.results)
            }
        });
    }

    const _OnlineUsers=(participants)=>{
        var online_users=[]
        participants.forEach((obj)=>{
            var last_online = obj.last_online;
            if(last_online)
            {
                var date_last_online = new Date(last_online);
                var now = new Date();
                var difference = now-date_last_online

                var Difference_In_Time = now.valueOf() - date_last_online.valueOf();
  
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                var Difference_In_MINS = Difference_In_Time / (1000 * 60);
                
                if(Difference_In_MINS<24*60)
                    online_users.push(obj)
                
            }
            
        })
        online_users.sort((a, b) => a.last_online > b.last_online ? -1 : 1);
        setOnlineUsers(online_users)
    }
    
    

   

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header hide-on-small">
                    <h1>
                        Online Users
                        <div className="bread-buttons">
                           

                        </div>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"><i className="fa fa-dashboard"></i> Home</a></li>
                    </ol>

                </section>
                <section className="content">

                    

                    <div className="row">

                        <section className="col-lg-12 connectedSortable ui-sortable">

                            <div className="box box-solid bg-dark">
                                <div className="box-header no-bg">
                                    <h3 className="box-title color-dark ">Online Members
                                        <small className="box-title-2">{onlineUsers && onlineUsers.length+1} online </small>
                                    </h3>

                                    <div className="box-tools pull-right">
                                        <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i>
                                        </button>
                                        <button type="button" className="btn btn-box-tool" data-widget="remove"><i className="fa fa-times"></i></button>
                                    </div>
                                </div>
                                <div className="box-body padding-x-15">
                                    <div className="row">
                                        {onlineUsers && onlineUsers.map((item, index) => (
                                            <div key={item.id}>
                                                <div  className="col-dashboard-user">
                                                    <a href={`usertalent/${item.id}`} class style={{ color: "white" }} >
                                                        <img src={userAvatar(item)} className="profile-user-img img-responsive img-circle" />
                                                        <p className="text-center font-size-11 mt-1">{item.first_name + " " + item.last_name}</p>
                                                        <p className="text-center font-size-11 mt-1">{moment(item.last_online).fromNow()}</p>
                                                    </a>
                                                </div>
                                                {index === 4 &&
                                                    <div className="clear"></div>
                                                }
                                            </div>
                                        )
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="box box-solid bg-blue-map">
                                <div className="box-header no-bg">
                                    <div className="pull-right box-tools">
                                        <button type="button" className="btn btn-primary-1 btn-sm pull-right" data-widget="collapse"
                                            data-toggle="tooltip" title="Collapse" style={{ marginRight: "5px" }}>
                                            <i className="fa fa-minus"></i></button>
                                    </div>
                                    <i className="fa fa-map-marker"></i>

                                    <h3 className="box-title ">
                                        Online Participants on world map
                                    </h3>
                                </div>
                                <div className="box-body">
                                    
                                    <DashboardWorldMap key={onlineUsers} participants={onlineUsers} callback={(countryCode,value)=>{ setWorldMapInfo(`${countryCode} : ${value} participants`) }} />
                                    
                                </div>
                                <div className="box-footer">
                                    <p className="color-dark">
                                    {worldMapInfo}
                                    </p>
                                </div>
                                
                            </div>

                        </section>

                    </div>
                </section>
            </div>
        </>


    )
}
